import classNames from "classnames";
import {Checkbox} from "@/shared/ui/Checkbox";
import {Radio} from "@/shared/ui/Radio";
import {FilterOption} from "../model/types";
import styles from "./CatalogSortOptionsFilter.module.scss";

type Props = {
    options: FilterOption[];
    selectedValue?: string;
    visibleOptionsCount?: number;
    loading?: boolean;
    showAll?: boolean;
    onChange: (
        option: FilterOption
    ) => void;
    onShowAll?: () => void;
    checkboxContainerClassName?: string;
    textPosition?: "left" | "right";
};

export const CatalogSortOptionsFilter = (
    {
        options,
        selectedValue,
        visibleOptionsCount = 8,
        loading = false,
        showAll = false,
        onChange,
        onShowAll,
        checkboxContainerClassName,
        textPosition = "right",
    }: Props
) => {
    return (
        <div className={classNames(styles.list, {[styles.loading]: loading})}>
            {options.map((option, index) => {
                const hidden = !showAll && index >= visibleOptionsCount;

                const commonProps = {
                    name: option.value,
                    value: option.value,
                    checked: selectedValue === option.value,
                    disabled: option.disabled,
                    className: classNames(checkboxContainerClassName, {[styles.hidden]: hidden}),
                    onChange: () => onChange(option),
                    label: option.label,
                    fullWidth: true,
                    textPosition,
                };

                if (option.type === "radio") {
                    return (<Radio key={option.id} {...commonProps} />);
                }

                return (<Checkbox key={option.id} {...commonProps} />);
            })}
            {!showAll && options.length > visibleOptionsCount && (
                <button type={`button`} className={styles.showAll} onClick={onShowAll}>
                    Посмотреть все
                </button>
            )}
        </div>
    );
};
